@use "../../styles/breakpoint.module.scss" as *;

.root {
    --image-width-mobile: min(50vw, 300px);
    --image-width-mobile-half: min(25vw, 150px);
    --labui-grid-gap: 0;

    margin-top: var(--spacer-152);

    @media ($below-mobile) {
        margin-top: calc(var(--image-width-mobile) - var(--spacer-152));
    }
}

.contentDesktop {
    // flexihero at this time doesn't have a concept of gapWidth that's at the
    // start of a row instead of in between content and media
    padding-left: calc(var(--labui-grid-column-width) + var(--labui-grid-gap));
    padding-block: var(--spacer-24);
}

.contentTablet {
    padding-block: var(--spacer-48);
}

.contentMobile {
    padding-block: var(--spacer-152);
}

.media {
    pointer-events: none;

    .image {
        aspect-ratio: 1;
        object-fit: cover;
    }
}

.mediaDesktop {
    composes: media;

    @media ($below-tablet) {
        height: 100%;
    }

    .picture {
        display: block;
        height: 100%;
        transform: translateY(calc(var(--spacer-152) * -1));

        // Nested for specificity reasons
        .image {
            width: calc(100% + var(--labui-container-margin));
            max-width: unset;
        }
    }
}

.mediaMobile {
    composes: media;
    height: 0;

    .picture {
        position: relative;
        display: block;
        width: 100%;
        height: var(--image-width-mobile-half);
        height: 0;
        transform: translateY(var(--spacer-152));

        .image {
            position: absolute;
            right: calc(var(--labui-container-margin) * -1);
            bottom: 0;
            width: var(--image-width-mobile);
        }
    }
}

.text {
    width: 100%;
}
